import * as React from 'react'
import PropTypes from 'prop-types'
import { graphql } from 'gatsby'

import CtaLink from './CtaLink'
import { InlineSectionHeading } from './SectionHeading'

export const ParagraphSection = ({ section, className = 'py-6 leading-loose', isDark = false }) => {
  const { heading, content, fields, removeTypography } = section
  let paragraphWithUpdatedImages
  paragraphWithUpdatedImages = fields ? fields.contentImg : null
  const htmlToRender = paragraphWithUpdatedImages ? paragraphWithUpdatedImages : content

  const contentHtml = {
    __html: (heading ? InlineSectionHeading(heading) : '') + htmlToRender,
  }
  let typographyClasses = ''
  if(removeTypography !== true)  {
    typographyClasses =  'prose lg:prose-xl marker:text-red-600 *:[&>*]:decoration-red-600 *:[&>*]:underline-offset-4 *:[&>*]:decoration-2'
    if(isDark)
      typographyClasses += ' prose-invert'
  }

  return (
    <section className={className || ' py-6 leading-loose flex'}>
      <div
        dangerouslySetInnerHTML={contentHtml}
        className={`${typographyClasses} mx-auto`}
      />
      {section.CTA && <CtaLink {...section.CTA} />}
    </section>
  )
}

ParagraphSection.propTypes = {
  section: PropTypes.shape({
    heading: PropTypes.string,
    content: PropTypes.string,
    fields: PropTypes.shape({
      contentImg: PropTypes.string,
    }),
    CTA: PropTypes.shape({
      title: PropTypes.string,
      url: PropTypes.string,
      openInNewTab: PropTypes.bool,
      download: PropTypes.bool,
    }),
    removeTypography: PropTypes.bool,
  }),
  className: PropTypes.string,
  isDark: PropTypes.bool,
}

ParagraphSection.defaultProps = {
  section: {
    heading: '',
    content: '',
    fields: {
      contentImg: '',
    },
    removeTypography: false,
  },
  className: 'py-6 leading-loose',
  isDark: false,
}

export const query = graphql`
  fragment ParagraphSection on STRAPI__COMPONENT_SECTION_PARAGRAPH {
    id
    heading
    strapi_component
    content
    fields {
      contentImg
    }
    CTA {
      ...CtaLink
    }
    removeTypography
  }
`

export default ParagraphSection
